import { InformationCircleIcon } from '@interstate/components/Icons/InformationCircleIcon';
import { Tooltip } from '@interstate/components/Tooltip';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import type { TradeInIntelligenceRowState } from '@makemydeal/dr-dash-types';

import { KBB_VEHICLE_TOOLTIP } from '../../constants';
import { DealPulseDividerStyle, DealPulseVehicleTitleStyle } from './DealPulseRow.style';

type TradeInIntelligenceHeaderProps = {
    rowState: TradeInIntelligenceRowState;
};

const TradeInIntelligenceHeader = ({ rowState }: TradeInIntelligenceHeaderProps) => {
    const theme = useInterstateTheme();

    if (rowState.resolution !== 'match' && rowState.resolution !== 'headsUp') {
        return null;
    }

    return (
        <>
            <DealPulseDividerStyle data-testid="trade-in-intelligence-divider" />
            {rowState.resolution === 'headsUp' && (
                <DealPulseVehicleTitleStyle data-testid="trade-in-intelligence-vehicle">
                    <span>{rowState.vehicle}</span>
                    <Tooltip
                        position="top"
                        toolTipContent={KBB_VEHICLE_TOOLTIP}
                        size="large"
                        data-testid="trade-in-intelligence-tooltip"
                    >
                        <InformationCircleIcon
                            color={theme.tokens.BaseColorBlue500}
                            tabIndex={0}
                            role="button"
                            aria-label={KBB_VEHICLE_TOOLTIP}
                            data-testid="trade-in-intelligence-info-icon"
                        />
                    </Tooltip>
                </DealPulseVehicleTitleStyle>
            )}
        </>
    );
};

export default TradeInIntelligenceHeader;
